import { combineReducers } from "redux"
import { Map } from 'immutable'

const INIT_STATE = {
  patient: null
}

export default combineReducers({
  patients: patients
})


function patients(state = Map(INIT_STATE), action) {
  switch (action.type) {
    case 'SET_PATIENT':
      return state.set("patient", action.payload);

    default:
      return state;
  }
}
